import { Switch, Button, Card, Collapse, CollapsePanel, Input, Tooltip, Icon, Loading } from '@citi-icg-172888/icgds-react';
import React, { useEffect, useState, useCallback } from 'react';
import LeadDataModal from './LeadDataModal';
import { validateLead } from '../../services/utils/utils';
import CreateCriteriaModal from './CreateCriteriaModal';
import { countChanges, isValidateField, removePropChange } from '../../services/utils/utils';
import { useData } from '../../services/context/DataContext';
import { postRequest } from '../../services/api/apiService';
import { GET_LEAD_ADMIN_SCORE } from '../../services/api/apiUrls';
import { v4 as uuid } from 'uuid';

const CreateLeadScoreView = () => {
    const { setErrorStatus, adminLeadData, setError, error } = useData();
    const originalData = adminLeadData?.existingWebLeadScoreDetails || {};
    const dataLength = Object.keys(originalData).length;
    const [leadData, setLeadData] = useState<any>({});
    const [isVisible, setIsVisible] = useState(false);
    const [updatedItem, setUpdatedItem] = useState<any>({});
    const [isCategoryModalVisible, setIsCategoryModalVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState("");
    const handleChange = useCallback(
        (ddName: string, e: React.ChangeEvent<HTMLInputElement>, indexValue: number, itemValue: any) => {
          const updatedData = { ...leadData };
          setLeadData(validateLead(ddName, e.target, updatedData, itemValue, indexValue));
        },
        [leadData, setLeadData]
      );
    useEffect(() => {
        if (Object.keys(originalData).length > 0) {
            setLeadData(JSON.parse(JSON.stringify(originalData)));
        }
    }, [dataLength > 0 && Object.keys(leadData).length == 0]);
    const handleClick = async () => {
        try {
            if (isValidateField(leadData)) {
                setIsCategoryModalVisible(false);
                setIsVisible(false);
                setError("");
                setUpdatedItem({});
                const data = removePropChange(leadData);
                setLeadData(data);
                adminLeadData.existingWebLeadScoreDetails = data;
                await postRequest(GET_LEAD_ADMIN_SCORE, adminLeadData);
            } else {
                setError("Please fill all the fields");
            }
        } catch (error) {
            setErrorStatus("API_FAILED_ERROR");
        }
    }

    useEffect(() => {
        const itemChange = countChanges(leadData, adminLeadData?.existingWebLeadScoreDetails);
        setUpdatedItem(itemChange);
    }, [leadData]);
    const handleLeadModal = (e: any, item: any) => {
        setIsVisible(!isVisible);
        setSelectedItem(item);
    }
    const handleLeadSubmission = (item: any) => {
        setLeadData(item);
        setIsVisible(!isVisible);
    }
    useEffect(() => {
        if (isCategoryModalVisible) {
            setIsVisible(false);
        }
    }, [isCategoryModalVisible])
    useEffect(() => {
        if (isVisible) {
            setIsCategoryModalVisible(false);
        }
    }, [isVisible])
    const handleCategorySubmission = (item: any) => {
        setLeadData(item);
        setIsCategoryModalVisible(!isCategoryModalVisible);
    }
    const toWordFormat = (str: string): string => {
        return str
            .replace(/([A-Z])/g, ' $1') // Add space before each uppercase letter
            .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize the first letter of each word
            .replace(/\bV C\b/g, 'VC') // Handle specific acronyms
            .replace(/\bP E\b/g, 'PE') // Handle specific acronyms
            .replace('V Cor PE', 'VC or PE'); // Handle the specific case for "VC or PE"
    };
    const handleHeader = (item: any) => {
        if (updatedItem?.changes && updatedItem?.changes?.[item]) {
            return <>{toWordFormat(item)} <Tooltip id={`tooltip-${item}`} placement="topLeft" tooltip={`${item} ${updatedItem.changes[item]} field changed`}><Icon type="info-circle" style={{ animation: 'popin-popout 1s infinite' }} /></Tooltip></>
        }
        return <>{toWordFormat(item)}</>
    }
    const handleClass = (item: any, index: number) => {
        if (updatedItem?.updatedItemChanged && updatedItem?.updatedItemChanged[item]?.length > 0) {
            return updatedItem?.updatedItemChanged?.[item]?.includes(index) && "lmn-bg-info"
        }
        return undefined
    }
    return (
        <div>
            {Object.keys(leadData).length === 0 ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Loading key={uuid()} showAnimatedSpinner />
            </div> :
                <Card className="lmn-w-75" id="lead_view" style={{ margin: '0 auto' }}>
                    {Object.keys(leadData).map((item: any) => {
                        return (
                            <>
                                <Collapse size={'default'} data-cv-tracking-id="collapse-tracking-id" style={{ marginBottom: "20px" }}>
                                    <CollapsePanel
                                        data-cv-tracking-id="collapse-panel-tracking-id"
                                        panelKey="1"
                                        header={handleHeader(item)}
                                        content={(<div key={uuid()} className="table">
                                            <div key={uuid()} className="row">
                                                <div className="cell">Field</div>
                                                <div className="cell">Criteria</div>
                                                <div className="cell">Factor</div>
                                                <div className="cell">Score</div>
                                                <div className="cell">Enable edit</div>
                                                <div className="cell">Enable rule</div>
                                            </div>
                                            {leadData[item]?.map((itemValue: any, indexValue: any) => <div key={indexValue} className={`row ${handleClass(item, indexValue)}`}>
                                                <div className="cell">
                                                    <p>{toWordFormat(item)}</p>
                                                </div>
                                                <div className="cell">
                                                    <p>{itemValue.name}</p>
                                                </div>
                                                <div className="cell">
                                                    <Input type="number" placeholder="Factor" disabled={!itemValue.editable} value={itemValue.factor} onChange={(e: any) => handleChange("factor", e, indexValue, item)} />
                                                </div>
                                                <div className="cell">
                                                    <Input type="number" placeholder="Score" disabled={!itemValue.editable} value={itemValue.score} onChange={(e: any) => handleChange("score", e, indexValue, item)} />
                                                </div>
                                                <div className="cell">
                                                    <Switch size="large" checked={itemValue.editable} onChange={(e: any) => handleChange("editable", e, indexValue, item)} />
                                                </div>
                                                <div className="cell">
                                                    <Switch size="large" checked={itemValue.applicable} onChange={(e: any) => handleChange("applicable", e, indexValue, item)} />
                                                </div>
                                            </div>)}
                                            <Button type="secondary" className='lmn-mt-4' onClick={(e: any) => handleLeadModal(e, item)}>Add {toWordFormat(item)}</Button>
                                        </div>)}
                                    />
                                </Collapse>
                            </>
                        );
                    })}
                    <Button type="secondary" style={{ width: '15%' }} className='lmn-mt-4' onClick={() => setIsCategoryModalVisible(!isCategoryModalVisible)}>Add New Category</Button>
                    <div className='lmn-d-flex lmn-justify-content-end'>
                        {error && <div className='lmn-text-danger lmn-align-content-center lmn-mr-24px'>{error}</div>}<Button type="primary" style={{ width: '15%' }} onClick={handleClick}>Save</Button>
                    </div>
                </Card>}
            {
                (!isVisible && isCategoryModalVisible) ? <CreateCriteriaModal size="default" visible={isCategoryModalVisible} data={leadData} handleCategorySubmission={handleCategorySubmission} /> :
                    isVisible && !isCategoryModalVisible && <LeadDataModal size="default" visible={isVisible} title={selectedItem} data={leadData} handleLeadSubmission={handleLeadSubmission} />
            }
        </div>
    );
};
export default React.memo(CreateLeadScoreView);